import React, { FC } from 'react';
import cls from './MonthModeBody.module.css';
import classNames from 'classnames';
import { MonthModeStage } from './MonthModeStage/MonthModeStage';

export const MonthModeBody = ({ stages }) => {
    return (
        <div className={classNames(cls.DaysModeBody)}>
            {stages.map((stage) => (
                <MonthModeStage key={stage.id} stage={stage} />
            ))}
        </div>
    );
};
